import * as ActionTypes from './ActionTypes';
import initialState from './InitialState';
import { assign } from '../../shared/Assign';

export default function productGroupReducer(
    state: any = initialState.productGroups,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.LOAD_PRODUCT_GROUPS_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }

        case ActionTypes.NEW_PRODUCT_GROUP_SUCCESS: {
            const newState = assign({}, state);
            newState.create = assign({}, action.result);
            return newState;
        }

        case ActionTypes.CREATE_PRODUCT_GROUP_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;
        }

        case ActionTypes.LOAD_EDIT_PRODUCT_GROUP_SUCCESS: {
            const newState = assign({}, state);
            newState.edit = assign({}, action.result);
            return newState;
        }

        case ActionTypes.UPDATE_PRODUCT_GROUP_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;
        }

        case ActionTypes.DELETE_PRODUCT_GROUP_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list.filter((x: any) => x.id !== action.result.id)];
            return newState;
        }

        default:
            return state;
    }
}
